import SetData from "@/vuex/SetData";
import Status from "@/vuex/Status";
import Config from "@/vuex/Config";
import CatchFetch from "@/assets/Cache/Fetch";
import Notification from "@/assets/Helper/Notification";
import Logger from "@/assets/Helper/Logger";

let DAOConvertItem = function () {

    this.byItemnumber = function (itemnumbers) {
        Status.dispatch('setLoading', true).catch((error) => {
            Logger.error(error);
        });

        return CatchFetch.cacheFirst(Config.getters.getApiHostWithLocalStr + '/v2/items/convert/' + itemnumbers.join('/') + '/')
            .then(json => {
                if (json.status) {
                    SetData.dispatch('setItemnumbers', json.result);

                    if (typeof json.alerts === 'object' && json.alerts.length > 0) {
                        for (let i in json.alerts) {
                            if (Object.prototype.hasOwnProperty.call(json.alerts, i)) {
                                Notification.create(json.alerts[i].title, json.alerts[i].text);
                            }
                        }
                    }
                }
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
            })
            .catch((error) => {
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
                Logger.error(error);
            });
    }

    this.getItemnumber = function (itemnumber) {
        return new Promise((resolve, reject) => {
            return CatchFetch.cacheFirst(Config.getters.getApiHostWithLocalStr + '/v2/items/convert/' + itemnumber + '/')
                .then(json => {
                    if (json.status) {
                        resolve(json.result);
                    }
                })
                .catch((error) => {
                    reject(false);
                    Logger.error(error);
                });
        });
    };
};

export default new DAOConvertItem();